export default "__VITE_ASSET__BGhrAtnj__"